export const TEMPLATE_OPTIONS = {interpolate: /{{([\s\S]+?)}}/g}
